module.exports = __webpack_public_path__ + "img/logo_login.22b0ff07.jpg";